var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"rpl-clearform",on:{"click":_vm.clearForm}},[_c('rpl-text-icon',{attrs:{"text":_vm.schema.buttonText,"symbol":"cross_circle","placement":"before","color":"danger","size":"0.833334"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }